export default {
  ELIXIO_CONNECT: {
    // --- Général ---
    ACCOUNTS: 'Comptes',
    VIEW_ELIXIO_CONNECT: 'Synchronisation',
    SOMETHING_WENT_WRONG: 'Une erreur est survenue',
    OPERATION_SUCCEEDED: 'Opération réussie',
    OPERATION_FAILED: 'Opération échouée',
    CONFIRMATION: 'Confirmation',
    YES: 'Oui',
    NO: 'Non',
    OK: 'OK',
    CANCEL: 'Annuler',
    CONTINUE: 'Continuer',
    CLOSE: 'Fermer',
    SEARCH: 'Recherche',
    PER_PAGE: 'Par page',
    STATUS: 'Statut',
    ALL_STATUSES: 'Tous les statuts',
    ALL: 'Tout',
    NONE: 'Aucun',
    NAME: 'Nom',
    EMAIL: 'Courriel',
    DATE: 'Date',
    TYPE: 'Type',
    DETAILS: 'Détails',
    VIEW: 'Voir',
    EDIT: 'Modifier',
    DELETE: 'Supprimer',
    UPDATE: 'Modifier',
    CREATED_AT: 'Créé le',
    UPDATED_AT: 'Mis à jour le',
    DATE_FROM: 'Du',
    DATE_TO: 'Au',
    CREATED_BY: 'Créé par',
    UPDATED_BY: 'Modifié par',
    DISPLAY_FROM_X_TO_X_OF_X_ENTRIES: 'Affichage de {from} à {to} sur {of} entrées',
    X_LINES_SELECTED: '{count} lignes sélectionnées',
    ERROR: 'Erreur',

    // --- Services / Modules ---
    ADD_ELIXIO_CONNECT_SERVICE: 'Ajouter un service',
    ADD_ELIXIO_CONNECT_CONFIGURE_THIS_SERVICE: 'Configurer',
    ELIXIO_CONNECT_SUBMIT: 'Soumettre',
    ELIXIO_CONNECT_TEST_CONFIG: 'Configurations Test',
    ELIXIO_CONNECT_PROD_CONFIG: 'Configurations Prod',
    ELIXIO_CONNECT_CONFIRM_THIS_SUBSCRIPTION: 'Confirmer cette action?',
    ELIXIO_ADDITIONNAL_CONFIG_TITLE: 'Configuration additionnelle',
    ELIXIO_START_CONNECT: 'Lancer',
    ELIXIO_PENDING_CONNECT: 'Mise à jour en cours...',
    ELIXIO_STOP_CONNECT: 'Arrêter',
    ELIXIO_TAB_DATA_TITLE: 'Synchroniser les données existantes',
    ELIXIO_TAB_CONFIG: 'Configuration',
    ELIXIO_TAB_UPDATE_DATA: 'Synchroniser les données existantes',
    ELIXIO_CONNECT_STATUS_PENDING: 'En cours',
    ELIXIO_CONNECT_STATUS_DONE: 'Terminé',
    ELIXIO_UPDATED_INVOICES: 'Synchronisation des factures',
    ELIXIO_UPDATED_PAYMENTS: 'Synchronisation des paiements',
    ELIXIO_UPDATED_CUSTOMERS: 'Synchronisation des clients',
    ELIXIO_CONNECT_COMPLETED: 'Synchronisation terminée',
    ELIXIO_CONNECT_CANCELLED: 'Synchronisation annulée',
    ELIXIO_CONNECT_TOTAL_PROGRESS: 'Progression totale',
    ELIXIO_START_IMPORT_AT: 'Démarrer à partir de:',
    SELECT_DATE: 'Sélectionner une date',
    ELIXIO_CONNECT_CONFIRM_THIS_DEACTIVATION: 'Confirmer cette désactivation?',
    ELIXIO_CONNECT_CONFIRM_THIS_REACTIVATION: 'Confirmer cette réactivation?',
    LOGIN_TO_YOUR_ACCOUNT: 'Connectez-vous à votre compte',
    MODULES: 'Modules disponibles',
    LOGIN_TO: 'Se connecter à',
    RE_LOGIN_TO: 'Se reconnecter à',
    DEACTIVATE: 'Désactiver',
    ACTIVATE: 'Activer',
    REACTIVATE: 'Réactiver',
    VALIDATE: 'Valider',
    ACTIVE: 'Actif',
    INACTIVE: 'Inactif',
    DEACTIVATED: 'Désactivé',
    CONFIGURE: 'Configurer',
    AUTH_FINISHED: 'Authentification terminée. Rafraîchissement en cours...',
    NOT_CONFIGURED_YET: 'Pas encore configuré',
    SUB_SERVICES: 'Services disponibles',
    NO_SUB_SERVICES: 'Aucun sous-service disponible',
    SHOW_SUB_SERVICES: 'Afficher les services',
    HIDE_SUB_SERVICES: 'Masquer les services',
    PARENT_AUTO_ACTIVATED: 'ElixioPay a été activé automatiquement',
    PARENT_AUTO_DEACTIVATED: 'ElixioPay a été désactivé automatiquement',
    SEARCH_SERVICES: 'Rechercher un service...',
    SERVICES: 'services',
    NO_RESULTS: 'Aucun résultat trouvé',
    LANGUAGE: 'Langue',
    TIMEZONE: 'Fuseau horaire',

    // --- GHL Import ---
    GHL_IMPORT_CONTACTS_TAB: 'Import des contacts',
    GHL_IMPORT_TITLE: 'Importer les contacts depuis GoHighLevel',
    GHL_IMPORT_START: "Lancer l'import",
    GHL_IMPORT_CONFIRM: 'Cela importera tous les contacts de votre compte GoHighLevel. Continuer ?',
    GHL_IMPORT_IN_PROGRESS: 'Import en cours...',
    GHL_IMPORT_CREATED: 'Créés',
    GHL_IMPORT_LINKED: 'Liés (existants)',
    GHL_IMPORT_UPDATED: 'Mis à jour',
    GHL_IMPORT_SKIPPED: 'Ignorés',
    GHL_IMPORT_ERRORS: 'Erreurs',
    GHL_IMPORT_COMPLETED: 'Import terminé avec succès !',
    GHL_IMPORT_FAILED: "L'import a échoué",
    GHL_IMPORT_ALREADY_RUNNING: 'Un import est déjà en cours',
    GHL_IMPORT_BACKGROUND_NOTE: "Vous pouvez quitter cette page. L'import continue en arrière-plan.",

    // --- Expéditions ---
    SHIPMENTS_LIST: 'Liste des expéditions',
    SHIPMENT: 'Expédition',
    SHIPMENT_STATUS_PENDING: 'En attente',
    SHIPMENT_STATUS_SHIPPED: 'Expédiée',
    SHIPMENT_STATUS: 'Statut',
    SHIPMENT_CREATED_AT: 'Créée le',
    SHIPMENT_STATUS_DRAFT: 'Brouillon',
    SHIPMENT_STATUS_ESTIMATED: 'Estimée',
    SHIPMENT_STATUS_CREATED: 'Créée',
    SHIPMENT_STATUS_PICKUP_CREATED: 'Ramassage créé',
    SHIPMENT_STATUS_IN_TRANSIT: 'En transit',
    SHIPMENT_STATUS_DELIVERED: 'Livrée',
    SHIPMENT_STATUS_EXCEPTION: 'Exception',
    SHIPMENT_STATUS_CANCELLED: 'Annulée',
    SHIPMENTS: 'Expéditions',
    NEW_SHIPMENT: 'Nouvelle expédition',
    NO_SHIPMENTS: 'Aucune expédition trouvée.',
    SHIPMENT_NAME: "Nom de l'expédition",
    ESTIMATE_SHIPMENT: "Estimer l'envoi",
    REDO_ESTIMATION: "Refaire l'estimation",
    ESTIMATION_CREATED: 'Estimation créée',
    ESTIMATION_UPDATED: 'Estimation mise à jour',
    ESTIMATION_DELETED: 'Estimation supprimée',
    CONFIRM_DELETE_ESTIMATION: 'Supprimer cette estimation ?',
    CONFIRM_SHIPMENT: "Confirmer l'expédition",
    SHIPMENT_CONFIRMED: 'Expédition confirmée',
    CONFIRM_CANCEL_SHIPMENT: "Annuler cette expédition ?",
    SHIPMENT_CANCELLED: 'Expédition annulée',
    CONFIRM_DELETE_SHIPMENT: 'Supprimer cette expédition annulée ? Cette action est irréversible.',
    SHIPMENT_DELETED: 'Expédition supprimée',
    LABEL_REMINDER_BEFORE_PICKUP: "Aucune étiquette d'expédition n'a été générée. L'étiquette ne sera plus disponible après la création du ramassage.",
    PRINT_LABEL_FIRST: 'Générer une étiquette',
    CONTINUE_WITHOUT_LABEL: 'Continuer sans étiquette',
    NO_RATES_AVAILABLE: 'Aucun tarif disponible pour cette estimation. Veuillez vérifier les données et réessayer.',
    EDIT_AND_REESTIMATE: 'Modifier et réestimer',
    AVAILABLE_RATES: 'Tarifs disponibles',
    SELECT_SERVICE: 'Choisir un service',
    GENERAL_INFORMATION: 'Informations générales',
    SENDER: 'Expéditeur',
    RECIPIENT: 'Destinataire',
    COMPANY_NAME: "Nom de l'entreprise",
    CONTACT_NAME: 'Nom du contact',
    ATTENTION_TO: "À l'attention de",
    PROVINCE: 'Province',
    POSTAL_CODE: 'Code postal',
    PACKAGING_TYPE: "Type d'emballage",
    WEIGHT_UNIT: 'Unité de poids',
    PAYMENT_TYPE: 'Type de paiement',
    PACKAGE_DETAILS: 'Détails du colis',
    DECLARED_VALUE: 'Valeur déclarée',
    PACKAGE: 'Colis',
    PACKAGES: 'colis',
    ADD_PACKAGE: 'Ajouter un colis',
    LENGTH: 'Longueur',
    WIDTH: 'Largeur',
    HEIGHT: 'Hauteur',
    WEIGHT: 'Poids',
    QUANTITY: 'Quantité',
    PRINT_LABEL: "Imprimer l'étiquette",
    PICKUP_DETAILS: 'Détails du ramassage',
    PICKUP_DATE: 'Date du ramassage',
    READY_AT: 'Heure prête',
    READY_UNTIL: 'Heure limite',
    TOTAL_WEIGHT: 'Poids total',
    PACKAGE_COUNT: 'Nombre de colis',
    PICKUP_LOCATION: 'Lieu de ramassage',
    INSTRUCTIONS: 'Instructions',
    CREATE_PICKUP: 'Créer le ramassage',
    CANCEL_PICKUP: 'Annuler le ramassage',
    PICKUP_CREATED: 'Ramassage créé',
    CONFIRM_CANCEL_PICKUP: 'Annuler le ramassage ?',
    PICKUP_CANCELLED: 'Ramassage annulé',
    Sender: 'Expéditeur',
    ThirdParty: 'Tiers',
    package: 'Colis',
    envelope: 'Enveloppe',
    'courier-pack': 'Colis express',
    freight: 'Fret',
    kg: 'Kilogrammes',
    lb: 'Livres',
    EightFiveByEleven: '8.5 x 11',
    FourBySix: '4 x 6',
    PACKAGING_PACKAGE: 'Colis',
    PACKAGING_ENVELOPE: 'Enveloppe',
    PACKAGING_COURIER_PACK: 'Colis express',
    PACKAGING_FREIGHT: 'Fret',
    WEIGHT_LB: 'Livres',
    WEIGHT_KG: 'Kilogrammes',
    LABEL_EIGHT_FIVE_BY_ELEVEN: '8.5 x 11',
    LABEL_FOUR_BY_SIX: '4 x 6',

    // Lieux de ramassage
    PICKUP_OUTSIDE_DOOR: 'Porte extérieure',
    PICKUP_FRONT_PORCH: 'Porche',
    PICKUP_OFFICE: 'Bureau',
    PICKUP_SIDE_DOOR: 'Porte latérale',
    PICKUP_BASEMENT: 'Sous-sol',
    PICKUP_FRONT_DESK: 'Réception',
    PICKUP_BETWEEN_DOORS: 'Entre les portes',
    PICKUP_SECURITY: 'Sécurité',
    PICKUP_COUNTER: 'Comptoir',
    PICKUP_LOBBY: 'Hall',
    PICKUP_MAILBOX: 'Boîte aux lettres',
    PICKUP_GATE_HOUSE: 'Guérite',
    PICKUP_DESK: 'Bureau',
    PICKUP_KIOSK: 'Kiosque',
    PICKUP_SHIPPING: 'Expédition',
    PICKUP_PRO_SHOP: 'Boutique Pro',
    PICKUP_FRONT_DOOR: "Porte d'entrée",
    PICKUP_RECEIVING: 'Réception',
    PICKUP_RECEPTION: 'Accueil',
    PICKUP_BACK_DOOR: 'Porte arrière',
    PICKUP_LAB: 'Laboratoire',
    PICKUP_MAIL_ROOM: 'Salle de courrier',
    PICKUP_GARAGE: 'Garage',
    PICKUP_PHARMACY: 'Pharmacie',
    PICKUP_SERVICE_COUNTER: 'Comptoir de service',
    PICKUP_PARTS_DEPARTMENT: 'Département des pièces',

    // --- E-sign / Signatures ---
    ESIGNS_LIST: 'Liste des packages',
    ADD_ESIGN: 'Créer un nouveau package',
    ESIGNS: 'Packages',
    ESIGN_ADDED: 'Package ajouté',
    EDIT_ESIGN: 'Modifier un package',
    ESIGN_UPDATED: 'Package mis à jour',
    DELETE_THIS_ESIGN: 'Supprimer ce package ?',
    ESIGN_DELETED: 'Package supprimé',
    ESIGN_TYPE: 'Type de package',
    VIEW_ESIGN: 'E-sign',
    PROPERTIES: 'Propriétés',
    WITHOUT_ADDRESS: "Ne pas mettre d'adresse",
    RETURN_TO_FORM: 'Retourner au formulaire',
    DRAFT: 'Brouillon',
    SENT: 'Envoyé',
    SENTS: 'Envoyées',
    COMPLETED: 'Complété',
    DECLINED: 'Refusé',
    EXPIRED: 'Expiré',
    CREATED: 'Créé',
    UPDATED: 'Mis à jour',
    DELETED: 'Supprimé',
    EMAIL_MESSAGE: 'Message à tous les destinataires (facultatif)',
    EDIT_TRANSACTION: 'Gérer',
    EDITOR: 'Éditeur',
    CANNOT_EDIT: 'Impossible de modifier ce package',
    CANNOT_DELETE: 'Impossible de supprimer ce package',
    CALL_BACK_URL: 'URL de rappel',

    // --- Modèles de signature ---
    MODELS: 'Modèles',
    MODELS_LIST: 'Liste des modèles',
    ADD_MODEL: 'Ajouter un modèle',
    MODELS_ADDED: 'Modèle ajouté',
    EDIT_MODEL: 'Modifier un modèle',
    MODELS_UPDATED: 'Modèle mis à jour',
    DELETE_THIS_MODEL: 'Supprimer ce modèle ?',
    MODELS_DELETED: 'Modèle supprimé',
    MODELS_TYPE: 'Catégorie du modèle',
    CATEGORY: 'Catégorie',
    VIEW_MODEL: 'Modèle',
    SAME_MODELS: "Un ou plusieurs modèles ont déjà été enregistrés avec le nom {name}. S'agit-il du même modèle ? Cliquez sur \"Continuer\" pour enregistrer si c'est le cas, sinon cliquez sur \"Annuler\".",
    SELECT: 'Sélectionner un modèle',
    DPA: 'Débit et crédit pré-autorisés',
    PPA: 'Paiement préautorisé',
    OTHERS: 'Autres',
    WHOLESALE_DEALER: "Modèle d'adhésion grossiste",
    DEALER: "Modèle d'adhésion concessionnaire",
    TYPE_REQUIRED: 'Veuillez sélectionner une catégorie',
    MODEL_DOCUMENTS: 'Documents du modèle',
    REPLACE_WITH: 'Remplacer par',
    DOCUMENT_NAME: 'Nom du document',
    YOU_CAN_CHANGE_DOCUMENTS: 'Vous pouvez remplacer les documents originaux par de nouveaux fichiers. Les zones de signature initiales seront préservées.',
    SELECT_A_FILE: 'Sélectionner un fichier',

    // --- Documents ---
    FILES: 'Documents',
    FILES_TO_BE_SIGN: 'Documents à signer',
    SIGNED_FILES: 'Documents signés',
    ADD_FILE: 'Ajouter un document',
    ADD_FILES: 'Ajouter les documents',
    DELETE_THIS_FILE: 'Supprimer ce document ?',
    FILE_DELETED: 'Document supprimé !',
    NAME_REQUIRED: 'Veuillez entrer le nom du document',
    SIGNATURE_PAGE: 'Page de signature',
    SIGNATURE_PAGE_REQUIRED: 'Le numéro de la page de signature est requis',
    SIGNATURE_TYPE: 'Type de signature',
    NO_SIGNATURES: 'Aucune signature',
    SIGNATURE_TYPE_REQUIRED: 'Le type de signature est requis',
    EDIT_FILE: 'Modifier le document',
    ADD_TEMPLATE_DOCUMENT: 'Ajouter un modèle de document',
    TEMPLATE_NAME: 'Modèle (vue)',
    TEMPLATE_NAME_REQUIRED: 'Le nom du modèle est requis',
    FILTER_MODELS: 'Filtrer les modèles',
    UNDETERMINED: 'Modèle indéterminé ?',
    DURATION: 'Durée en mois',
    MODEL_REQUIRED: 'Veuillez sélectionner un modèle !',

    // --- Champs de signature ---
    FULLNAME: 'Nom et prénom',
    INITIALS: 'Initiales',
    CAPTURE: 'Capture de signature',
    LABEL: 'Étiquette',
    TEXTFIELD: 'Champ texte court',
    TEXTAREA: 'Zone de texte',
    CHECKBOX: 'Case à cocher',
    RADIO: 'Boutons radio',
    LIST: 'Liste déroulante',
    QRCODE: 'Code QR',
    CUSTOMFIELD: 'Champ personnalisé',
    SEAL: 'Pièce jointe',
    MOBILE_CAPTURE: 'Capture mobile',
    RAW_CAPTURE: 'Capture brute',
    DATEPICKER: 'Sélecteur de date',
    DPA_CREDIT: 'Dépôt direct',
    DPA_DEBIT: 'Prélèvement pré-autorisé',

    // --- Pages de signature ---
    SIGNATURE_PAGES: 'Pages de signature',
    SIGNATURE_PAGES_REQUIRED: 'Vous devez ajouter au moins une page de signature',
    SIGNATURE_POSITION_PAGE_NUMBER: 'Numéro',
    SIGNATURE_POSITION_PAGE_NUMBER_REQUIRED: 'Le numéro est requis',
    SIGNATURE_POSITION_X: 'X',
    SIGNATURE_POSITION_Y: 'Y',
    SIGNATURE_POSITION_WIDTH: 'Largeur',
    SIGNATURE_POSITION_HEIGHT: 'Hauteur',
    ADD_SIGNATURE_PAGE: 'Ajouter une page',

    // --- Signatures ---
    SIGNATURES: 'Signatures',
    SIGNATURE: 'Signature',
    SIGNATURES_LIST: 'Liste des signatures',
    ADD_SIGNATURE: 'Ajouter une signature',
    SIGNATURE_ADDED: 'Signature ajoutée',
    EDIT_SIGNATURE: 'Modifier une signature',
    SIGNATURE_UPDATED: 'Signature mise à jour',
    DELETE_THIS_SIGNATURE: 'Supprimer cette signature ?',
    SIGNATURE_DELETED: 'Signature supprimée',
    VIEW_SIGNATURE: 'Signature',
    SAME_SIGNATURES: "Une ou plusieurs signatures ont déjà été enregistrées avec le nom \"{name}\". S'agit-il de la même signature ?",
    MODELS_REQUIRED: 'Veuillez sélectionner un contrat',
    SELECT_MODEL: 'Sélectionnez un modèle',

    // --- Signataires ---
    SIGNERS: 'Signataires',
    SIGNERS_REQUIRED: 'Veuillez ajouter au moins un signataire',
    ADD_SIGNER: 'Ajouter un signataire',
    SEND: 'Envoyer',
    RESEND: 'Renvoyer',
    SEND_FOR_SIGN_MESSAGE: 'Confirmez-vous vouloir envoyer cette demande aux différents signataires ?',
    SIGNATURE_SENT: 'Demande de signature envoyée !',
    SIGNATURE_NOT_SENT: "Échec de l'envoi de la signature, merci de compléter les informations requises",
    SIGNERS_EMAIL_MESSAGE: "Un message pour accompagner l'e-mail de signature ?",
    EMAIL_MESSAGE_TITLE: 'E-mail de signature',
    RESEND_SIGNATURE_EMAIL: 'Renvoyer pour signer',
    VIEW_DETAILS: 'Voir plus',
    GET_DOCUMENTS: 'Charger les documents signés',
    DOCUMENTS_CHARGED: 'Documents chargés avec succès !',
    FROM_MODEL: "À partir d'un modèle",
    FROM_TEMPLATE: "À partir d'un modèle",
    ROLES: 'Rôle des différents signataires',
    ADD_ROLES: 'Saisissez pour ajouter des rôles',
    ROLES_REQUIRED: 'Veuillez ajouter les différents rôles',
    SEND_FOR_SIGNATURE: 'Envoyer immédiatement pour signature',
    DOCUMENT: 'Document',
    ROLE: 'Rôle',
    DOCUMENTS_PAYLOAD: 'Champs à remplir pour les documents',
    CLONE_MODEL: 'Cloner un modèle',

    // --- Champs de formulaire ---
    FIRSTNAME: 'Prénom',
    LASTNAME: 'Nom',
    PASSWORD: 'Mot de passe',
    ADDRESS: 'Adresse',
    PHONE: 'Téléphone',
    COUNTRY: 'Pays',
    COUNTRIES: 'Pays',
    STATES: 'Régions',
    STATE: 'Région',
    CITY: 'Ville',
    ZIPCODE: 'Code postal',
    NOTE: 'Note',
    AMOUNT: 'Montant',
    TITLE: 'Titre',
    CODE: 'Code',
    COLOR: 'Couleur',
    EXCERPT: 'Description',
    PICTURE: 'Photo',
    UNIT_PRICE: 'Prix unitaire',
    SUBTOTAL: 'Sous-total',
    PRICE: 'Prix',
    RATE: 'Taux (%)',
    TAXES: 'Taxes',
    PAYMENTS: 'Paiements',
    USERS: 'Utilisateurs',
    USER: 'Utilisateur',
    OWNER: 'Propriétaire',
    EMAILS: 'Emails',
    EMAILS_CC: 'Cc',
    EMAILS_CCI: 'Cci',
    TEMPLATES_MAILS: 'Modèles de courriel',
    GLOBAL: 'Global',
    NUMBER: 'N°',

    // --- Validation ---
    EMAIL_REQUIRED: 'Le courriel est requis',
    EMAIL_INCORRECT: 'Courriel invalide',
    FIRSTNAME_REQUIRED: 'Le prénom est requis',
    LASTNAME_REQUIRED: 'Le nom est requis',
    ROLE_MUST_BE_UNIQUE: 'Le rôle doit être unique',
    NO_SIGNERS: 'Aucun signataire assigné.',
    SIGNER_STATUS_SIGNED: 'Signé',
    SIGNER_STATUS_PENDING: 'En attente',
    SIGNER_STATUS_DECLINED: 'Refusé',
    SENT_AT: 'Envoyé le',
    COMPLETED_AT: 'Complété le',
    SIGNATURE_NOT_FOUND: 'Signature introuvable.',
    SHOW_TEMPLATES_FIELDS_CODES: 'Afficher les codes des champs du modèle',
    COPY: 'Copier',
    FIELDS_CODES: 'Codes des champs',
    NO_FIELD_FOUND: 'Aucun champ trouvé',
    SEARCH_FIELD: 'Rechercher un champ...',
    START_TYPING_CITY_REGION_COUNTRY: "Commencez par saisir la ville, la région ou le pays pour compléter l'adresse.",
    FIELD_REQUIRED: 'Ce champ est requis',
    ROLE_REQUIRED: 'Le rôle est requis',
    FOR_SIGNATURE: 'pour signature',

    // --- Modèles de courriel ---
    MT_MAIL_TEMPLATE: 'Modèle de courriel',
    MT_MAIL_TYPE: 'Type de courriel',
    MT_SELECT_TYPE: 'Sélectionner un type de courriel',
    MT_TYPE_REQUIRED: 'Veuillez sélectionner un type de courriel',
    MT_SUBJECT: 'Sujet',
    MT_SECTIONS: 'Sections',
    MT_ADD_SECTION: 'Ajouter une section',
    MT_FROM_EMAIL: 'De (courriel)',
    MT_FROM_NAME: 'De (nom)',
    MT_REPLY_TO: 'Répondre à',
    MT_RECIPIENTS: 'Destinataires',
    MT_IS_DEFAULT: 'Modèle par défaut',
    MT_STYLING: 'Style',
    MT_BACKGROUND_COLOR: 'Couleur de fond',
    MT_TITLE_STYLE: 'Style du titre',
    MT_TEXT_STYLE: 'Style du texte',
    MT_LINKS_STYLE: 'Style des liens',
    MT_FOOTER_STYLE: 'Style du pied de page',
    MT_BUTTONS_COLORS: 'Couleurs des boutons',
    MT_FONT_FAMILY: 'Police',
    MT_FONT_SIZE: 'Taille',
    MT_VARIABLES: 'Variables disponibles',
    MT_PREVIEW: 'Aperçu',
    MT_PREVIEW_HINT: "Cliquez sur « Aperçu » pour générer l'aperçu du courriel.",
    MT_ADD: 'Ajouter un modèle de courriel',
    MT_EDIT: 'Modifier le modèle de courriel',
    MT_CREATE: 'Créer',
    MT_UPDATE: 'Modifier',
    MT_CREATED: 'Modèle de courriel créé',
    MT_UPDATED: 'Modèle de courriel mis à jour',
    MT_DELETED: 'Modèle de courriel supprimé',
    MT_CONFIRM_DELETE: 'Supprimer ce modèle de courriel ?',
    MT_NO_TEMPLATES: 'Aucun modèle de courriel trouvé.',
    MT_NOT_FOUND: 'Modèle de courriel introuvable.',
    MT_DEFAULT: 'Par défaut',
    MT_TEMPLATE_DETAILS: 'Détails du modèle',
    MT_REFRESH_PREVIEW: "Actualiser l'aperçu",
  },

  // ── Mail V2 ─────────────────────────────────────────────────────
  MV2: {
    TEMPLATES_LIST: 'Liste des modèles',
    MAIL_SETTINGS: 'Paramètres mail',
    ALL_CATEGORIES: 'Toutes les catégories',
    ALL_STATUS: 'Tous les statuts',
    TRANSACTIONAL: 'Transactionnel',
    NOTIFICATION: 'Notification',
    MARKETING: 'Marketing',
    CUSTOMIZED: 'Personnalisé',
    USING_DEFAULT: 'Par défaut',
    CUSTOMIZE: 'Personnaliser',
    CUSTOMIZE_CONFIRM: 'Personnaliser le modèle « {name} » ? Une copie sera créée pour votre organisation.',
    CUSTOMIZE_ERROR: 'Erreur lors de la personnalisation du modèle.',
    TEMPLATE_CUSTOMIZED: 'Modèle personnalisé avec succès.',
    RESET_DEFAULT: 'Rétablir par défaut',
    RESET_CONFIRM: 'Rétablir le modèle par défaut ? Vos personnalisations seront perdues.',
    RESET_ERROR: 'Erreur lors du rétablissement du modèle.',
    TEMPLATE_RESET: 'Modèle rétabli par défaut.',
    EDIT_TEMPLATE: 'Modifier le modèle',
    TEMPLATE_SAVED: 'Modèle enregistré avec succès.',
    SAVE_ERROR: "Erreur lors de l'enregistrement.",
    NO_TEMPLATES: 'Aucun modèle trouvé.',
    SUBJECT: 'Objet',
    SUBJECT_PLACEHOLDER: "Objet de l'email...",
    FROM_NAME: 'Nom expéditeur',
    FROM_EMAIL: 'Email expéditeur',
    REPLY_TO: 'Email réponse',
    REPLY_TO_NAME: 'Nom réponse',
    REPLY_TO_EMAIL: 'Email réponse',
    VARIABLES: 'Variables',
    CLICK_TO_INSERT: 'Cliquer pour insérer',
    COPY_FROM: 'Copier depuis',
    COPY_LABEL: 'Copier {from} \u2192 {to}',
    SENDER_OVERRIDE: 'Exp\u00e9diteur',
    SEND_TEST: 'Envoyer un test',
    TEST_EMAIL_PLACEHOLDER: 'adresse@test.com',
    SEND: 'Envoyer',
    TEST_SENT: 'Email de test envoyé.',
    TEST_ERROR: "Erreur lors de l'envoi du test.",
    TYPE_SETTINGS: 'Paramètres du type',
    CODE: 'Code',
    CATEGORY: 'Catégorie',
    REFRESH: 'Actualiser',
    PREVIEW_HINT: 'Sélectionnez un modèle pour afficher l\'aperçu.',
    // Settings
    SENDER_DEFAULTS: 'Expéditeur par défaut',
    DEFAULT_LOCALE: 'Langue par défaut',
    BRANDING: 'Identité visuelle',
    LOGO_URL: 'URL du logo',
    LOGO_HEIGHT: 'Hauteur du logo (px)',
    PRIMARY_COLOR: 'Couleur primaire',
    SECONDARY_COLOR: 'Couleur secondaire',
    FOOTER: 'Pied de page',
    FOOTER_TEXT: 'Texte du pied de page',
    UNSUBSCRIBE_URL: 'URL de désinscription',
    SETTINGS_SAVED: 'Paramètres enregistrés.',
    // Admin
    LAYOUTS: 'Layouts',
    LAYOUT_NAME: 'Nom du layout',
    LAYOUT_SAVED: 'Layout enregistré.',
    TYPES_LIST: 'Types de mail',
    DEFAULT_TEMPLATE: 'Modèle par défaut',
    CANCEL: 'Annuler',
    SAVE: 'Enregistrer',
    SELECT_TEMPLATE: 'Sélectionner un template mail...',
  },
}
